<template>
  <div class="operate-release-flow-add">
    <Card shadow class="content">
      <div class="main">
        <Row class="title">
          <h4 :style="{float: 'left'}">申请运维流程</h4>
        </Row>
        <!-- <GeneralAlert></GeneralAlert> -->
        <Form inline :label-width="70" :rules="baseInfoFormRules" ref="baseInfo" :model="baseInfo">
          <Row>
            <Col span="24">
              <FormItem label="标题" style="width: 100%" prop="title">
                <Input :maxlength="100" v-model="baseInfo.title" placeholder="请填写申请标题"/>
              </FormItem>
            </Col>
            <!-- <Col span="24">
              <FormItem label="版本号" style="width: 100%" prop="version">
                <Input :maxlength="100" v-model="baseInfo.version" placeholder="请填写版本号"/>
              </FormItem>
            </Col> -->
          </Row>
          <Row>
          <Col span="24">
              <FormItem label="优先级" style="width: 100%" prop="priority">
                <RadioGroup v-model="baseInfo.priority" type="button">
                  <Radio :label="0">普通</Radio>
                  <Radio :label="1">紧急</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
            <Col span="24">
              <FormItem label="流程类型" style="width: 100%" prop="type">
                 <RadioGroup v-model="baseInfo.type" @on-change="onSelectPm">
                    <radio v-for="envModeItem in all_type_list" :key="envModeItem.key" :label="envModeItem.key">{{ envModeItem.label }}</radio>
                    <!-- <Radio label="0">网络变更</Radio>
                    <Radio label="1">防火墙变更</Radio>
                    <Radio label="2">远程桌面开通</Radio> -->
                </RadioGroup>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="变更内容" style="width: 100%" prop="describe">
                <vue-editor v-model="baseInfo.describe" ref="myQuillEditorBody" :editorOptions="editorOptionBody" class="operate-release-add-content"></vue-editor>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="附件" style="width: 100%">
                 <Upload  :action="operateReleaseFlowUploadEnclosureUrl"
                          :headers="uploadHeader"
                          :on-success="uploadEnclosureSuccess"
                          :on-error="uploadEnclosureError"
                          :on-format-error="uploadEnclosureFormatError"
                          :on-exceeded-size="uploadEnclosureExceededSize"
                          :show-upload-list="true"
                          :max-size="50240">
                      <Button icon="ios-cloud-upload-outline" size="small">点击上传</Button>
                    </Upload>
                    <Alert type="warning" show-icon>只能上传一个文件,上传多次以最后一次上传的文件为准</Alert>
              </FormItem>
            </Col>
          </Row>
          <!-- <Row>
            <Col span="24">
              <FormItem label="项目文档SVN地址" style="width: 100%" prop="test_report_address">
                <Input :maxlength="500" v-model="baseInfo.test_report_address" :rows="6" placeholder="请填写项目文档SVN地址" />
              </FormItem>
            </Col>
          </Row> -->
          <!-- <Row>
            <Col span="24">
              <FormItem label="产品经理" prop="pm" style="width: 100%" v-show="pm_visible">
                <Select v-model="baseInfo.pm" placeholder="请选择此次发布版本对应的产品经理" clearable filterable>
                  <Option v-for="item in all_user_list" :key="item.key" :value="item.key" :label="item.label"></Option>
                </Select>
              </FormItem>
            </Col>
          </Row> -->
           <Row>
            <Col span="24">
              <FormItem
                  v-if="baseInfo.type"
                  v-for="(item, index) in baseInfo.steps"
                  :key="index"
                  :label="item.name"
                  :prop="'steps.' + index + '.users_sel'"
                  :rules="{required: true, message: '步骤-' + item.id +'不能为空', trigger: 'change', type: 'array'}">
              <i-select v-model="item.users_sel" filterable multiple disabled>
                <i-option v-for="user in item.users" :value="user.username" :key="user.id" :label="user.name"></i-option>
              </i-select>
            </FormItem>
          </Col>
          </Row>
          <div style="text-align: center;">
            <Button type="primary" style="margin-right: 10px" :loading="submitting" @click.native="submit">提交申请</Button>
            <Button @click="$router.go(-1)">取消</Button>
          </div>
        </Form>
      </div>
    </Card>
  </div>
</template>

<script>
import { createOperateReleaseFlow, operateReleaseFlowUploadEnclosureUrl, getOpsTypeReleaseSteps } from '@/api/workflow/operate_release_flow'
import { getAllOpsTypes } from '@/api/workflow/ops-flow-type'
import { getModuleAllList } from '@/api/workflow/project'
import GeneralAlert from '../components/general-alert'
import { forEach } from '@/libs/tools'
// quill editor
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { VueEditor } from 'vue2-editor'
import { GetALLUsers } from '@/api/user'

export default {
  name: 'edit',
  components: {
    GeneralAlert,
    VueEditor
  },
  data () {
    return {
      pm_visible: false,
      all_user_list: [],
      all_type_list: [],
      editorOptionBody: {
        modules: {
          toolbar: []
        }
      },
      operateReleaseFlowUploadEnclosureUrl: operateReleaseFlowUploadEnclosureUrl,
      uploadHeader: {
        Authorization: 'OPS ' + this.$store.state.user.token,
        DefaultTenant: this.$store.state.user.defaultTenant,
        SelTenants: this.$store.state.user.selTenants
      },
      baseInfo: {
        title: '',
        describe: '',
        module: [],
        version: '',
        priority: 0,
        type: null,
        enclosure: '',
        test_report_address: '',
        pm: '',
        steps: [
          {
            id: null,
            name: null,
            users: [],
            users_sel: []
          }
        ]
      },
      version: {},
      baseInfoFormRules: {
        title: { required: true, message: '标题不能为空', trigger: 'blur' },
        priority: { required: true, message: '请选择优先级', trigger: 'blur', type: 'number' },
        type: { required: true, message: '请选择流程类型', type: 'number', trigger: 'change' },
        describe: { required: true, message: '流程内容不能为空', trigger: 'blur' }
      },
      moduleList: [],
      submitting: false
    }
  },
  mounted: function () {
    // this.getModuleList()
    // this.fetchStepsData()
    // this.getAllUsersData()
    this.getAllOpsTypes()
  },
  // watch: {
  //   '$store.state.user.defaultTenant' () {
  //     this.fetchStepsData()
  //     // this.getModuleList()
  //   }
  // },
  methods: {
    onSelectPm (value) {
      this.fetchStepsData()
    },
    initPm (value) {
      this.baseInfoFormRules.pm[0].required = value
    },
    // 获取所有类型列表
    getAllOpsTypes () {
      this.all_type_list = []
      let params = {
      }
      getAllOpsTypes(params).then(res => {
        let result = res.data
        for (let i in result) {
          this.all_type_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },
    // 获取所有用户列表
    getAllUsersData () {
      this.all_user_list = []
      let params = {
        'group_name': '产品组'
      }
      GetALLUsers(params).then(res => {
        let result = res.data
        for (let i in result) {
          this.all_user_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },
    fetchStepsData () {
      console.log(1111)
      this.baseInfo.steps = []
      let data = {
        type_id: this.baseInfo.type
      }
      getOpsTypeReleaseSteps(data).then(res => {
        if (res.data.data instanceof Array && res.data.data.length > 0) {
          this.baseInfo.steps = res.data.data
          this.baseInfo.steps.map(item => {
            item.users_sel = item.users.map(j => j.username)
          })
          console.log(this.baseInfo.steps)
        }
      })
    },
    // 上传测试报告附件成功
    uploadEnclosureSuccess (res, file) {
      console.log(file)
      if (res) {
        if (this.baseInfo.enclosure) {
          this.baseInfo.enclosure = `${this.baseInfo.enclosure},${res}`
        } else {
          this.baseInfo.enclosure = res
        }

        this.$Notice.success({
          title: '上传成功'
        })
      }
    },
    // 上传测试报告附件失败
    uploadEnclosureError (err, msg) {
      this.$Notice.error({
        title: '上传失败',
        desc: msg
      })
      console.log(err)
    },
    // 上传测试报告格式不对
    uploadEnclosureFormatError () {
      this.$Notice.error({
        title: '只能上传格式为docx/xlsx/pdf的文件'
      })
    },
    // 上传测试报告超过限制大小
    uploadEnclosureExceededSize () {
      this.$Notice.error({
        title: '限制文件大小为50M'
      })
    },
    // 获取模块列表
    getModuleList () {
      this.$refs.releaseModules.clearSingleSelect()
      getModuleAllList({ tenant_id__in: this.$store.state.user.defaultTenant }).then(res => {
        this.moduleList = res.data
      })
    },
    // 提交
    submit () {
      this.$refs.baseInfo.validate((valid) => {
        if (valid) {
          forEach(this.baseInfo.steps, (item, index) => {
            let stepName = 'step_' + (index + 1)
            this.baseInfo[stepName] = item.users_sel
          })
          this.submitting = true
          createOperateReleaseFlow(this.baseInfo).then(res => {
            this.$Notice.success({ title: '操作成功' })
            this.$router.push({ name: 'operateReleaseFlowDetail', params: { id: res.data.id } })
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .operate-release-add-content {
    .ql-toolbar {
      display: none;
    }
    .ql-container {
      border-radius: 4px;
      border-top: 1px solid #ccc !important;
    }
  }
</style>
